import React, { useCallback } from 'react';
import { DatePicker } from 'antd';
import { Button } from '@peoplegrove/pg-components';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { useConversationSnapshotFiltersContext } from '../../context/ConversationSnapshotFiltersContext';
import SnapshotFiltersDropdown from '../../components/SnapshotFiltersDropdown';
import { disabledDate } from '../../utils/core';
import classes from './ConversationSnapshots.module.scss';

const { RangePicker } = DatePicker;

const SnapshotFilters = () => {
  const {
    pendingFilters,
    setSnapshotFilters,
    resetFilters,
    applyFilters,
    isDirty,
    enableClearAll,
  } = useConversationSnapshotFiltersContext();

  const handleFilterChange = useCallback(
    (filter, value) => {
      setSnapshotFilters(filter, value);
    },
    [setSnapshotFilters]
  );

  const handleClearAllFilters = useCallback(() => {
    resetFilters();
  }, [resetFilters]);

  const handleDateRangeChange = useCallback(
    (dateObj, dateStrs) => {
      if (isEmpty(dateObj)) {
        handleFilterChange('dateRange', null);
      } else {
        const [startDate, endDate] = dateStrs;
        handleFilterChange('dateRange', { start: startDate, end: endDate });
      }
    },
    [handleFilterChange]
  );

  return (
    <div className={classes.filtersContainer}>
      <div className={classes.dateFilter}>
        <RangePicker
          value={
            pendingFilters.dateRange
              ? [
                  moment(pendingFilters.dateRange.start),
                  moment(pendingFilters.dateRange.end),
                ]
              : []
          }
          onChange={handleDateRangeChange}
          disabledDate={disabledDate}
          format="MM/DD/YYYY"
          allowClear
          aria-label="Date range for conversation snapshot"
        />
      </div>
      <div className={classes.filtersDropdown}>
        <SnapshotFiltersDropdown />
      </div>
      <div className={classes.filterButtonsContainer}>
        <Button
          type="secondary"
          disabled={!isDirty}
          onClick={applyFilters}
          size="small"
        >
          Apply Filters
        </Button>

        <Button
          type="secondary"
          color="red"
          size="small"
          disabled={!enableClearAll}
          onClick={handleClearAllFilters}
        >
          Clear All
        </Button>
      </div>
    </div>
  );
};

export default SnapshotFilters;
